<div class="container-fluid twitter-session-page">
  <app-content-tab-list activeTab="3" type="twitter" category="Twitter"></app-content-tab-list>

  <div class="session-heading mt-4">
    <div class="home-details">
      <h5 class="home-title">Posting Session</h5>
      <p class="home-subtitle mb-0">
        Manage the OAuth token used by automated jobs to post on X.
      </p>
    </div>
    <button
      type="button"
      class="btn btn-outline-primary"
      (click)="showRefreshTokenModal = true"
    >
      Update refresh token
    </button>
  </div>

  @if (showRefreshTokenModal) {
    <div class="modal-backdrop" (click)="showRefreshTokenModal = false"></div>
    <div class="refresh-token-modal">
      <h5>Update Refresh Token</h5>
      <form
        #refreshTokenForm="ngForm"
        autocomplete="off"
        (ngSubmit)="saveRefreshToken()"
      >
        <div class="form-group">
          <label for="oauth-refresh-token">New refresh token</label>
          <input
            id="oauth-refresh-token"
            name="refreshToken"
            class="form-control"
            type="password"
            autocomplete="new-password"
            placeholder="Paste your new refresh token"
            [(ngModel)]="refreshTokenInput"
            required
          />
        </div>
        <div class="modal-actions">
          <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="showRefreshTokenModal = false"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary btn-dashboard"
            [disabled]="refreshTokenForm.invalid || oauthSubmitting"
          >
            {{ oauthSubmitting ? "Saving..." : "Save" }}
          </button>
        </div>
      </form>
    </div>
  }

  <div class="row mt-4">
    <div class="col-12">
      <section class="session-card">
        <div class="card-heading d-flex align-items-center justify-content-between">
          <div>
            <h5>Tweet Post History</h5>
            <p class="mb-0">All tweets posted from the backend (word-cloud, text, ...).</p>
          </div>
          <select
            class="form-control status-filter"
            [(ngModel)]="postsStatusFilter"
            [ngModelOptions]="{ standalone: true }"
            (change)="loadPosts(1)"
          >
            <option value="">All statuses</option>
            <option value="success">Success</option>
            <option value="failed">Failed</option>
          </select>
        </div>

        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>Tweet</th>
                <th>Status</th>
                <th>Posted</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (post of posts; track post._id) {
                <tr>
                  <td>{{ post.text }}</td>
                  <td>
                    <span
                      class="badge"
                      [class.badge-success]="post.status === 'success'"
                      [class.badge-danger]="post.status === 'failed'"
                    >
                      {{ post.status }}
                    </span>
                    @if (post.status === 'failed' && post.error) {
                      <div class="small text-danger">{{ post.error }}</div>
                    }
                  </td>
                  <td>{{ post.createdAt | date: "medium" }}</td>
                  <td>
                    @if (post.imageUrl || post.tweetUrl) {
                      <div class="dropdown">
                        <button class="btn btn-dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <span class="text-primary text-nowrap">View actions <i class="las la-angle-down align-middle"></i></span>
                        </button>
                        <div class="dropdown-menu">
                          @if (post.tweetUrl) {
                            <a class="dropdown-item" [href]="post.tweetUrl" target="_blank">View tweet</a>
                          }
                          @if (post.imageUrl) {
                            <a class="dropdown-item" [href]="post.imageUrl" target="_blank">View image</a>
                          }
                        </div>
                      </div>
                    } @else {
                      <span class="text-muted">No actions</span>
                    }
                  </td>
                </tr>
              }
              @if (!postsLoading && !posts.length) {
                <tr>
                  <td colspan="4" class="text-center">No tweets posted yet.</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        @if (postsTotal > postsPerPage) {
          <nav>
            <ul class="pagination">
              <li class="page-item" [class.disabled]="postsPage <= 1">
                <button class="page-link" (click)="loadPosts(postsPage - 1)">Prev</button>
              </li>
              <li class="page-item" [class.disabled]="postsPage * postsPerPage >= postsTotal">
                <button class="page-link" (click)="loadPosts(postsPage + 1)">Next</button>
              </li>
            </ul>
          </nav>
        }
      </section>
    </div>
  </div>
</div>
